import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import { SupabaseBrandKitService } from "../../brand-kit/server/brand-kit-service";
import { SupabaseAccountService } from "../server/supabase-account-service";

export const useAccountBrand = (): UseSupabaseLoaderState<{
  name: string;
  logo?: string;
}> =>
  useSupabaseLoader(async ({ supabase, account_id }) => {
    const [{ data: accountData }, { data: logoData }] = await Promise.all([
      new SupabaseAccountService(supabase).get(account_id),
      new SupabaseBrandKitService(supabase).getDefaultLogo(account_id),
    ]);

    return {
      name: accountData?.name ?? "",
      logo: logoData?.brand_logo?.src ?? undefined,
    };
  }, []);
